/**
 * Variant Image Filter
 * Filters product gallery images based on alt text matching variant option values.
 * - If image alt contains a variant value (e.g. "Mavi"), show only when that value is selected
 * - If image alt doesn't match any variant value, show for all variants (generic image)
 */
(function () {
  'use strict';

  // Inject hide class
  var style = document.createElement('style');
  style.textContent = '.variant-image-hidden{display:none!important}';
  document.head.appendChild(style);

  function initFilter(mediaGallery) {
    var sectionId = mediaGallery.id.replace('MediaGallery-', '');
    var dataEl = document.getElementById('VariantImageFilterData-' + sectionId);
    if (!dataEl) return;

    var optionGroups;
    try {
      optionGroups = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!optionGroups || optionGroups.length === 0) return;

    // Pre-compute lowercase values for case-insensitive matching
    optionGroups.forEach(function (g) {
      g._lower = g.values.map(function (v) {
        return (typeof v === 'object' ? v.name || String(v) : String(v)).toLowerCase();
      });
      g.values = g.values.map(function (v) {
        return typeof v === 'object' ? v.name || String(v) : String(v);
      });
    });

    function getSelectedValues() {
      var pi = mediaGallery.closest('product-info');
      var vs = pi ? pi.querySelector('variant-selects') : document.querySelector('variant-selects');
      if (!vs) return {};

      var sel = {};

      // Fieldsets (swatch / pill pickers)
      vs.querySelectorAll('fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend) return;
        var name = legend.textContent.split(':')[0].trim();
        var checked = fs.querySelector('input:checked');
        if (checked) sel[name] = checked.value;
      });

      // Dropdowns
      vs.querySelectorAll('.product-form__input--dropdown select').forEach(function (s) {
        var m = s.name.match(/^options\[(.+)\]$/);
        if (m) sel[m[1]] = s.value;
      });

      return sel;
    }

    function shouldShow(alt) {
      if (!alt || !alt.trim()) return true;

      var altLower = alt.toLowerCase();
      var selected = getSelectedValues();

      for (var i = 0; i < optionGroups.length; i++) {
        var group = optionGroups[i];
        var matchedInGroup = [];

        for (var j = 0; j < group.values.length; j++) {
          if (group._lower[j] && altLower.indexOf(group._lower[j]) !== -1) {
            matchedInGroup.push(group.values[j]);
          }
        }

        if (matchedInGroup.length > 0) {
          // Image is tagged for this option group — selected value must match
          var selectedVal = selected[group.name];
          if (!selectedVal) continue;

          var found = false;
          for (var k = 0; k < matchedInGroup.length; k++) {
            if (matchedInGroup[k].toLowerCase() === selectedVal.toLowerCase()) {
              found = true;
              break;
            }
          }
          if (!found) return false;
        }
      }

      return true; // generic (no tag matched) or all tagged groups passed
    }

    function filterImages() {
      var galleryList = mediaGallery.querySelector('[id^="Slider-Gallery-"]');
      var thumbList = mediaGallery.querySelector('[id^="Slider-Thumbnails-"]');
      if (!galleryList) return;

      var items = galleryList.querySelectorAll(':scope > li[data-media-id]');
      var firstVisibleId = null;

      items.forEach(function (item) {
        var alt = item.getAttribute('data-media-alt') || '';
        var show = shouldShow(alt);
        item.classList.toggle('variant-image-hidden', !show);
        if (show && !firstVisibleId) firstVisibleId = item.dataset.mediaId;
      });

      // Sync thumbnails
      if (thumbList) {
        thumbList.querySelectorAll(':scope > li[data-target]').forEach(function (thumb) {
          var slide = galleryList.querySelector('[data-media-id="' + thumb.dataset.target + '"]');
          if (slide) {
            thumb.classList.toggle('variant-image-hidden', slide.classList.contains('variant-image-hidden'));
          }
        });
      }

      // Activate first visible slide
      if (firstVisibleId) {
        items.forEach(function (item) { item.classList.remove('is-active'); });
        var first = galleryList.querySelector('[data-media-id="' + firstVisibleId + '"]');
        if (first) {
          first.classList.add('is-active');
          first.parentElement.scrollTo({ left: first.offsetLeft, behavior: 'instant' });
        }

        if (thumbList) {
          thumbList.querySelectorAll('button').forEach(function (b) { b.removeAttribute('aria-current'); });
          var aThumb = thumbList.querySelector('[data-target="' + firstVisibleId + '"] button');
          if (aThumb) aThumb.setAttribute('aria-current', 'true');
        }
      }

      // Let slider recalculate
      var viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
      if (viewer && viewer.resetPages) viewer.resetPages();
    }

    // Subscribe to Shopify pub/sub events
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        requestAnimationFrame(filterImages);
      });

      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(filterImages, 120);
      });
    }

    // Initial filter
    filterImages();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
